import * as React from "react";

/*Begin: Copied from piral*/
export interface PiralCustomExtensionSlotMap {}

export interface PiralExtensionSlotMap extends PiralCustomExtensionSlotMap {}

export type ExtensionSlotProps<K = string> = BaseExtensionSlotProps<
  K extends string ? K : string,
  K extends keyof PiralExtensionSlotMap ? PiralExtensionSlotMap[K] : K extends string ? any : K
>;

export interface BaseExtensionSlotProps<TName, TParams> {
  /**
   * Defines what should be rendered when no components are available
   * for the specified extension.
   */
  empty?(): React.ReactNode;
  /**
   * Defines how the provided nodes should be rendered.
   * @param nodes The rendered extension nodes.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  render?(nodes: Array<React.ReactNode>): React.ReactElement<any, any> | null;
  /**
   * The custom parameters for the given extension.
   */
  params?: TParams;
  /**
   * The name of the extension to render.
   */
  name: TName;
}
/*End: Copied from piral*/

export type ExtensionType = <TName>(props: ExtensionSlotProps<TName>) => React.ReactElement | null;

interface IExtensionContextProviderProps {
  value: ExtensionType;
  children: React.ReactNode;
}

export const ExtensionContext = React.createContext<ExtensionType | null>(null);

export const useExtensionContext = () => React.useContext(ExtensionContext);

export const ExtensionContextProvider = (props: IExtensionContextProviderProps) => (
  <ExtensionContext.Provider value={props.value}>{props.children}</ExtensionContext.Provider>
);
